import { t, x } from 'helpers/localization'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import dwhExport from '~/dwhExport'
import { Interpolate } from 'react-i18next'
import { PURPOSES } from '../../../Actions/ActionRecommendations'
import { ClanRecommendation, RecommendationsPurpose } from '../../../Actions/ActionRecommendations'
import ClanCard from '../ClanCard/ClanCard'
import { RECOMMENDATIONS_ROOT_PATH } from '../constants'
import styles from './ClanCardSlider.scss'

export type IProps = {
    purpose: RecommendationsPurpose,
    currentSlide: number,

    returnToCategories: () => void,
    onClanSelect: (clanId: number) => void,
    isClanSelectingEnabled: Boolean,
    clans: Array<ClanRecommendation>,
    errorMessage: any,

    root: String,
}

class ClanCardSlider extends PureComponent<IProps, any> {

    constructor(props) {
        super(props)

        this.slideLeft = this.slideLeft.bind(this)
        this.slideRight = this.slideRight.bind(this)
    }

    UNSAFE_componentWillReceiveProps(nextProps: IProps, nextContext) {

    }

    getAvailableSlide(currentSlide: number, props: ?IProps) {
        return Math.max(Math.min(currentSlide, this.slideCount(props) + 1), 1)
    }

    slideCount(props: ?IProps = null) {
        if (props === null) {
            props = this.props
        }
        return Math.ceil(props.clans.length / 3) - 1
    }

    slideLeft() {
        dwhExport.send(`clanrec.${this.props.purpose}.change_page_left`)
        const currentSlide = this.getAvailableSlide(this.getAvailableSlide(this.props.currentSlide) - 1)
        this.context.router.push(`${this.props.root}${RECOMMENDATIONS_ROOT_PATH}/${this.props.purpose}/${currentSlide}`)
    }

    slideRight() {
        dwhExport.send(`clanrec.${this.props.purpose}.change_page_right`)
        const currentSlide = this.getAvailableSlide(this.getAvailableSlide(this.props.currentSlide) + 1)
        this.context.router.push(`${this.props.root}${RECOMMENDATIONS_ROOT_PATH}/${this.props.purpose}/${currentSlide}`)
    }

    render() {
        const hasClans = this.props.clans.length !== 0

        const clansContent = this.props.clans.map((clan, index) => (
            <ClanCard
                key={clan.id}
                cssLevel={index % 3 + 1}
                clanId={clan.id}
                onClanSelect={this.props.onClanSelect}
                isClanSelectingEnabled={this.props.isClanSelectingEnabled}
                errorMessage={this.props.errorMessage}
                tag={clan.tag}
                name={clan.name}
                color={clan.color}
                description={clan.description}
                languages={clan.languages}
                memberCount={clan.memberCount}
                isVoiceRequired={clan.isVoiceRequired}
                similarity={clan.similarity}
                purpose={this.props.purpose}
                root={this.props.root} />
        ))

        const currentSlide = this.getAvailableSlide(this.props.currentSlide) - 1
        const translateX = - 100 * currentSlide

        const showLeftControl = currentSlide > 0
        const showRightControl = currentSlide < this.slideCount()

        const noClanMessage = (
            <div className={styles.noClanMessage} onClick={this.props.returnToCategories}>
                <Interpolate
                    i18nKey={x('Подходящих Вам кланов не найдено, попробуйте %(searchPreferences)s')}
                    searchPreferences={<span className={styles.link}>{t('изменить условия подбора')}</span>}
                    t={t} />
            </div>
        )

        const slider = (
            <div className={styles.wrapper}>
                <div className={styles.sliderWrapper}>
                    <div
                        style={{transform: `translate3d(${translateX}%, 0, 0)`}}
                        className={styles.sliderContent}>
                        {clansContent}
                    </div>
                </div>
                {showLeftControl ? <div onClick={this.slideLeft} className={styles.leftControl} /> : null}
                {showRightControl ? <div onClick={this.slideRight} className={styles.rightControl} /> : null}
            </div>
        )

        return hasClans ? slider : noClanMessage
    }
}

ClanCardSlider.contextTypes = {
    router: PropTypes.object.isRequired,
}

ClanCardSlider.defaultProps = {
    purpose: PURPOSES.NO_OBLIGATIONS,
    currentSlide: 1,

    returnToCategories: () => {},
    onClanSelect: (clanId: number) => {},
    isClanSelectingEnabled: true,
    clans: [],

    root: '',
}

export default ClanCardSlider